import type { AppExperience, AppSuiteEffective } from '../../types/appSuites'

export interface ExperienceInput {
  platformOnly: boolean
  flagOn: boolean
  suite: AppSuiteEffective | null
  userChoice: AppExperience | null
}

/** Classic unless every gate allows the four-app shell. */
export function resolveExperience(input: ExperienceInput): AppExperience {
  if (input.platformOnly || input.suite?.platform_only) return 'classic'
  if (!input.flagOn || !input.suite || !input.suite.apps.some((app) => app.enabled)) {
    return 'classic'
  }
  if (input.suite.allow_experience_switch && input.userChoice) return input.userChoice
  return input.suite.default_experience
}
